// List of Modals to show
export const MODALS = {
  API: 'api',
  ORDER: 'order',
  DOWNLOAD: 'download',
  STREAM: 'stream',
  LOGIN: 'login',
  SAVE_SEARCH: 'saveSearch',
  SHARE: 'shareSession',
  TOUR: 'tour',
  DOWNLOAD_AOI: 'downloadAoi',
  UPLOAD: 'upload',
  POST_QUOTA_RESERVE: 'postQuotaReserve',
  QUOTA_MANAGER: 'quota',
  SHARE_COLLECTION: 'shareCollection',
  DELETE_COLLECTION: 'deleteCollection',
  EDIT_COLLECTION: 'editCollection',
};
